// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Logo: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="56" viewBox="0 0 50 56">
            <defs>
                <linearGradient id="a" x1="50.093%" x2="10.728%" y1="23.663%" y2="104.94%">
                    <stop offset="0%" stop-color="#009FD7" />
                    <stop offset="30.96%" stop-color="#0096D2" />
                    <stop offset="69.98%" stop-color="#008DCD" />
                    <stop offset="100%" stop-color="#008BCC" />
                </linearGradient>
                <linearGradient id="b" x1="89.244%" x2="49.879%" y1="104.94%" y2="23.663%">
                    <stop offset="0%" stop-color="#008BCC" />
                    <stop offset="30.36%" stop-color="#008DCD" />
                    <stop offset="65.15%" stop-color="#0094D1" />
                    <stop offset="100%" stop-color="#009FD7" />
                </linearGradient>
                <linearGradient id="c" x1="-2.724%" x2="64.446%" y1="21.58%" y2="83.797%">
                    <stop offset="0%" stop-color="#008BCC" />
                    <stop offset="30.12%" stop-color="#008DCD" />
                    <stop offset="66.26%" stop-color="#0095D1" />
                    <stop offset="100%" stop-color="#009FD7" />
                </linearGradient>
                <linearGradient id="d" x1="42.427%" x2="75.477%" y1="20.496%" y2="87.91%">
                    <stop offset="0%" stop-color="#009FD7" />
                    <stop offset="33.74%" stop-color="#0095D1" />
                    <stop offset="69.88%" stop-color="#008DCD" />
                    <stop offset="100%" stop-color="#008BCC" />
                </linearGradient>
                <linearGradient id="e" x1="20.987%" x2="63.251%" y1="64.593%" y2="22.831%">
                    <stop offset="0%" stop-color="#008BCC" />
                    <stop offset="30.12%" stop-color="#008DCD" />
                    <stop offset="66.26%" stop-color="#0095D1" />
                    <stop offset="100%" stop-color="#009FD7" />
                </linearGradient>
                <linearGradient id="f" x1="0%" x2="100.012%" y1="49.995%" y2="49.995%">
                    <stop offset="0%" stop-color="#008BCC" />
                    <stop offset="31.22%" stop-color="#008DCD" />
                    <stop offset="63.6%" stop-color="#0093D0" />
                    <stop offset="96.41%" stop-color="#009ED6" />
                    <stop offset="100%" stop-color="#009FD7" />
                </linearGradient>
            </defs>
            <g fill="none">
                <polygon fill="url(#a)" points="50 45.791 30.922 55.816 30.922 36.604" />
                <polygon fill="url(#b)" points="0 45.791 19.078 55.816 19.078 36.604" />
                <polygon fill="url(#c)" points="24.994 0 50 13.139 38.468 19.435 24.994 19.435" />
                <polygon
                    fill="url(#d)"
                    points="50 45.791 50 38.223 50 20.697 50 13.139 38.468 19.435 30.922 24.291 30.922 36.604"
                />
                <polygon
                    fill="url(#e)"
                    points="0 45.791 0 37.821 0 21.11 0 13.139 11.52 19.435 19.078 24.291 19.078 36.604"
                />
                <polygon fill="url(#f)" points="24.994 0 0 13.139 11.52 19.435 24.994 19.435" />
            </g>
        </svg>
    );
};

export default React.memo(Logo);
